<template>
  <a-upload
    name="avatar"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :customRequest="uploadImg"
    :before-upload="beforeUpload"
    @change="handleChange"
  >
    <img v-if="imageUrl || defaultUrl" :src="imageUrl || defaultUrl" alt="avatar" style="width: 200px"/>
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
  </a-upload>
</template>
<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
const OSS = require('ali-oss')
import OssApi from '../api/src/oss/api/OssApi'
const ossApi = new OssApi()
export default {
  name: 'Upload',
  data() {
    return {
      loading: false,
      imageUrl: '',
    };
  },
  props: {
    path: String,
    defaultUrl: String
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      // if (info.file.status === 'done') {
      //   // Get this url from response in real world.
      //   getBase64(info.file.originFileObj, imageUrl => {
      //     this.imageUrl = imageUrl;
      //     this.loading = false;
      //   });
      // }
    },
    async beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('文件必须小于 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadImg(info) {
      console.log(info)
      let res = {}
      if(this.path) {
        res = await ossApi.getStsAkV2(this.path)
      }else{
        res = await ossApi.getStsAk()
      }
      console.log(res)
      let region = res.endpoint;
      let fKey = region.indexOf('//') + 2;
      let lKey = region.indexOf('.');
      let client = new OSS({
        region: region.substring(fKey,lKey),
        accessKeyId: res.accessKeyId,
        accessKeySecret: res.accessKeySecret,
        stsToken: res.securityToken,
        bucket: res.bucketName,
      })

      let tempCheckpoint;
      client.multipartUpload(`${this.path || res.url}${info.file.uid}.jpg` , info.file, {
        progress: (p, checkpoint) => {
          // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
          tempCheckpoint = checkpoint;
          console.log(p, checkpoint)
          if(p == 1){
            let endpointPath = res.endpoint.split('/')
            let endpoint = endpointPath[endpointPath.length - 1]
            let url
            if(checkpoint){
              url = `https://${res.bucketName}.${endpoint}/${checkpoint.name}`;
            }else{
              url = `https://${res.bucketName}.${endpoint}/${this.path || res.url}${info.file.uid}.jpg`
            }
            console.log(url)
            info.file.status = 'done'
            this.$emit('changeImgUri', `${this.path || res.url}${info.file.uid}.jpg`)
            this.imageUrl = url;
            this.loading = false;
          }
        },
      }).catch(err => {
        console.log(err)
      })
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>